module.exports = __webpack_public_path__ + "static/cable-5984df342d04d2e0d47e057f7e663fba.jpg";